// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type TopicDetails_TopicModelAsEditor_Fragment = (
  { __typename?: 'TopicModelAsEditor' }
  & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
  & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicVersionModel' }
    & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
  )>, author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'image_url' | 'display_name'>
  ), coverImage?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'DocumentModel' }
    & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
  )>, coverImageVariants: Array<(
    { __typename?: 'ImageVariantModel' }
    & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl' | 'file_url' | 'size_key'>
  )>, lastEnrolment?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'status' | 'completion_date'>
  )> }
);

export type TopicDetails_TopicModelAsMember_Fragment = (
  { __typename?: 'TopicModelAsMember' }
  & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicVersionModel' }
    & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'readDurationMins' | 'summary'>
  )>, author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'image_url' | 'display_name'>
  ), coverImage?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'DocumentModel' }
    & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
  )>, coverImageVariants: Array<(
    { __typename?: 'ImageVariantModel' }
    & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl' | 'file_url' | 'size_key'>
  )>, lastEnrolment?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'status' | 'completion_date'>
  )> }
);

export type TopicDetailsFragment = TopicDetails_TopicModelAsEditor_Fragment | TopicDetails_TopicModelAsMember_Fragment;

export type PathwayDetailPageQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  specificVersion: PrivateSchemaTypes.Scalars['Boolean'];
  version?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['JSON']>;
}>;


export type PathwayDetailPageQuery = (
  { __typename?: 'Query' }
  & { pathway?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'PathwayModelAsStudent' }
    & Pick<PrivateSchemaTypes.PathwayModelAsStudent, 'id' | 'title' | 'description' | 'progress' | 'published_date' | 'production_pathway_version_id' | 'updated_at' | 'state' | 'allow_comments'>
    & { owner: (
      { __typename?: 'UserModel' }
      & Pick<PrivateSchemaTypes.UserModel, 'id' | 'display_name'>
    ), latestVersion: PrivateSchemaTypes.Maybe<Array<(
      { __typename?: 'PathwayVersionModelAsStudent' }
      & Pick<PrivateSchemaTypes.PathwayVersionModelAsStudent, 'id' | 'version'>
      & { topics: Array<(
        { __typename?: 'TopicModelAsMember' }
        & TopicDetails_TopicModelAsMember_Fragment
      )> }
    )>>, specificVersion: PrivateSchemaTypes.Maybe<Array<(
      { __typename?: 'PathwayVersionModelAsStudent' }
      & Pick<PrivateSchemaTypes.PathwayVersionModelAsStudent, 'id' | 'version'>
      & { topics: Array<(
        { __typename?: 'TopicModelAsMember' }
        & TopicDetails_TopicModelAsMember_Fragment
      )> }
    )>>, currentEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.PathwayEnrolmentModelAsStudent, 'id' | 'progress' | 'completed_at' | 'status' | 'completed_status' | 'importedAt' | 'newTopicsInPathway' | 'notificationMessage'>
      & { topicEnrolments: Array<(
        { __typename?: 'TopicEnrolmentModelAsStudent' }
        & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'topic_id' | 'progress' | 'completion_date' | 'status' | 'canBeUpdated'>
        & { topicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'allow_retry' | 'summary' | 'readDurationMins' | 'title'>
        )> }
      )>, pathwayVersion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PathwayVersionModel' }
        & Pick<PrivateSchemaTypes.PathwayVersionModel, 'id' | 'version'>
      )> }
    )>, coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
    )>, tags: Array<(
      { __typename?: 'TagModel' }
      & Pick<PrivateSchemaTypes.TagModel, 'name' | 'id'>
    )> }
  )> }
);

export type PathwayOpenedFromCampaignShareEmailMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  scheduledActionId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type PathwayOpenedFromCampaignShareEmailMutation = (
  { __typename?: 'Mutation' }
  & { pathway?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'PathwayModelAsStudent' }
    & Pick<PrivateSchemaTypes.PathwayModelAsStudent, 'id' | 'openedFromCampaignShareEmail'>
  )> }
);

export const TopicDetailsFragmentDoc = gql`
    fragment TopicDetails on ITopicModel {
  id
  currentTopicVersion {
    id
    title
    readDurationMins
    summary
  }
  author {
    id
    image_url
    display_name
  }
  coverImage {
    id
    cdnUrl
  }
  coverImageVariants {
    cdnUrl
    file_url
    size_key
  }
  lastEnrolment {
    id
    status
    completion_date
  }
}
    `;
export const PathwayDetailPageDocument = gql`
    query pathwayDetailPage($id: PositiveInt!, $specificVersion: Boolean!, $version: JSON) {
  pathway(id: $id) {
    id
    title
    description
    progress
    published_date
    production_pathway_version_id
    updated_at
    state
    allow_comments
    owner {
      id
      display_name
    }
    latestVersion: versions(order: {name: "id", sort: "DESC"}, limit: 1) @skip(if: $specificVersion) {
      id
      version
      topics {
        ...TopicDetails
      }
    }
    specificVersion: versions(filters: [{name: version, value: $version}]) @include(if: $specificVersion) {
      id
      version
      topics {
        ...TopicDetails
      }
    }
    currentEnrolment {
      id
      progress
      completed_at
      status
      completed_status
      importedAt
      newTopicsInPathway
      notificationMessage
      topicEnrolments {
        id
        topic_id
        progress
        completion_date
        status
        canBeUpdated
        topicVersion {
          id
          allow_retry
          summary
          readDurationMins
          title
        }
      }
      pathwayVersion {
        id
        version
      }
    }
    coverImage {
      id
      cdnUrl
    }
    tags {
      name
      id
    }
  }
}
    ${TopicDetailsFragmentDoc}`;

/**
 * __usePathwayDetailPageQuery__
 *
 * To run a query within a React component, call `usePathwayDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayDetailPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      specificVersion: // value for 'specificVersion'
 *      version: // value for 'version'
 *   },
 * });
 */
export function usePathwayDetailPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PathwayDetailPageQuery, PathwayDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PathwayDetailPageQuery, PathwayDetailPageQueryVariables>(PathwayDetailPageDocument, options);
      }
export function usePathwayDetailPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathwayDetailPageQuery, PathwayDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PathwayDetailPageQuery, PathwayDetailPageQueryVariables>(PathwayDetailPageDocument, options);
        }
export type PathwayDetailPageQueryHookResult = ReturnType<typeof usePathwayDetailPageQuery>;
export type PathwayDetailPageLazyQueryHookResult = ReturnType<typeof usePathwayDetailPageLazyQuery>;
export type PathwayDetailPageQueryResult = Apollo.QueryResult<PathwayDetailPageQuery, PathwayDetailPageQueryVariables>;
export const PathwayOpenedFromCampaignShareEmailDocument = gql`
    mutation pathwayOpenedFromCampaignShareEmail($id: PositiveInt!, $scheduledActionId: PositiveInt!) {
  pathway(id: $id) {
    id
    openedFromCampaignShareEmail(scheduledCampaignActionId: $scheduledActionId)
  }
}
    `;
export type PathwayOpenedFromCampaignShareEmailMutationFn = Apollo.MutationFunction<PathwayOpenedFromCampaignShareEmailMutation, PathwayOpenedFromCampaignShareEmailMutationVariables>;

/**
 * __usePathwayOpenedFromCampaignShareEmailMutation__
 *
 * To run a mutation, you first call `usePathwayOpenedFromCampaignShareEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathwayOpenedFromCampaignShareEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathwayOpenedFromCampaignShareEmailMutation, { data, loading, error }] = usePathwayOpenedFromCampaignShareEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scheduledActionId: // value for 'scheduledActionId'
 *   },
 * });
 */
export function usePathwayOpenedFromCampaignShareEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PathwayOpenedFromCampaignShareEmailMutation, PathwayOpenedFromCampaignShareEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PathwayOpenedFromCampaignShareEmailMutation, PathwayOpenedFromCampaignShareEmailMutationVariables>(PathwayOpenedFromCampaignShareEmailDocument, options);
      }
export type PathwayOpenedFromCampaignShareEmailMutationHookResult = ReturnType<typeof usePathwayOpenedFromCampaignShareEmailMutation>;
export type PathwayOpenedFromCampaignShareEmailMutationResult = Apollo.MutationResult<PathwayOpenedFromCampaignShareEmailMutation>;
export type PathwayOpenedFromCampaignShareEmailMutationOptions = Apollo.BaseMutationOptions<PathwayOpenedFromCampaignShareEmailMutation, PathwayOpenedFromCampaignShareEmailMutationVariables>;